import { render, staticRenderFns } from "./ShippersAccountsReceivable.vue?vue&type=template&id=280354c8&scoped=true"
import script from "./ShippersAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./ShippersAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./ShippersAccountsReceivable.vue?vue&type=style&index=0&id=280354c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280354c8",
  null
  
)

export default component.exports